"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommentsCountElement = void 0;
const MetaElement_1 = require("./MetaElement");
class CommentsCountElement extends MetaElement_1.MetaElement {
    constructor(options) {
        super(options);
    }
    getCommentsButton() {
        if (!this.shadowRoot) {
            return;
        }
        return this.shadowRoot.querySelector('.comments-button');
    }
    getCommentsCounter() {
        if (!this.shadowRoot) {
            return;
        }
        return this.shadowRoot.querySelector('.comments-counter');
    }
}
exports.CommentsCountElement = CommentsCountElement;
